__turbopack_context__.v({
  "logo": "RMYTqa_logo",
});
